import type { MetaFunction } from '@remix-run/node'
import { Container } from '~/application/components/Container/Container'
import { Content } from '~/application/components/Content/Content'
import { Heading } from '~/application/components/Heading/Heading'
import { FaqItem } from '~/application/components/FaqItem/FaqItem'
import { getMeta } from '~/application/services/metaService'

export const meta: MetaFunction = ({ location }) => {
  return getMeta({
    title: 'FAQ',
    url: location.pathname,
  })
}

export default function Index() {
  return (
    <Content>
      <Container size="sm">
        <header className="mb-8">
          <Heading title="FAQ" />
        </header>
        <div className="flex flex-col gap-8">
          <h2 className="text-2xl">アカウント</h2>
          <FaqItem title="アカウントの作成方法">
            <p>
              ヘッダーのアカウント作成からemail、パスワードをご入力の上作成可能です。
            </p>
          </FaqItem>
          <FaqItem title="アカウントの削除方法">
            <p>
              ログイン後、「ダッシュボード」→ 「設定/プロフィール」→
              「アカウント削除」より削除可能です。
            </p>
          </FaqItem>

          <h2 className="text-2xl">料金</h2>
          <FaqItem title="利用に料金はかかりますか？">
            <p>現在は完全無料のFreeプランのみご利用いただけます。</p>
          </FaqItem>

          <h2 className="text-2xl">スポンサー</h2>
          <FaqItem title="スポンサーを募集するにはどうすればいいですか？">
            <p>
              ログイン後、ダッシュボード内のメニュー「設定/スポンサー」からスポンサーを受け付ける設定を変更してくだい。
              <br />
              またユーザーページの公開も必須になるためダッシュボード内のメニュー「設定/プロフィール」からページ公開をオンにしてください。
            </p>
          </FaqItem>
          <FaqItem title="スポンサーになるにはどうすればいいですか？">
            <p>
              スポンサーになるには団体登録する必要があります。
              <br />
              ログイン後、ダッシュボード内のメニュー「団体作成」から作成をしてください。
              <br />
            </p>
            <p>
              スポンサーを募集しているユーザーのページからスポンサーの申請を送信できます。
            </p>
          </FaqItem>
          <FaqItem title="個人としてスポンサーになることはできますか？">
            <p>
              スポンサーになるには団体である必要があります。
              <br />
              法人など自身が所属するスポンサーをする団体の登録をしてください。
            </p>
          </FaqItem>

          <h2 className="text-2xl">投稿・活動報告</h2>
          <FaqItem title="投稿と活動報告の違いはなんですか？">
            <p>
              投稿：他のユーザーに対してのお知らせや近況の報告などにお使いください。
              <br />
              活動報告：主にスポンサーに向けて自身の活動の結果報告や活動の予定の報告にお使いください（全体に公開することも可能）
            </p>
          </FaqItem>
          <FaqItem title="スポンサーにのみ公開するにはどうすればいいですか？">
            <p>
              投稿・活動報告の作成、編集画面の公開範囲からスポンサーのみを選択してください。
            </p>
          </FaqItem>
        </div>
      </Container>
    </Content>
  )
}
